import {Divider, Grid, Typography} from "@mui/material";
import {Fragment} from "react";

export const WordPressQuoteRatingCar = ({
                                            redirectToApp,
                                            lng,
                                            carRate,
                                            carRateFromAI,
                                            NoRate,
                                            RegisterLink,
                                            Coupon,
                                            Feedback
                                        }) => {

    if (+carRate?.finalTotal === 0) {
        return (
            <Fragment>
                <Grid size={{xs: 12}}>
                    <NoRate/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Feedback/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <RegisterLink/>
                </Grid>
                <Grid size={{xs: 12}}>
                    <Coupon/>
                </Grid>
                {redirectToApp()}
            </Fragment>
        )
    }

    return (
        <Fragment>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '小计' : "Subtotal"}
                </Typography>
            </Grid>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                    $ {(+carRate?.totalCharge || +carRateFromAI?.subtotal).toFixed(2)}
                </Typography>
            </Grid>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '税费' : "Tax"}
                </Typography>
            </Grid>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                    $ {(+carRate?.taxCharge || +carRateFromAI?.tax || 0).toFixed(2)}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Divider/>
            </Grid>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '总计' : "Total"}
                </Typography>
            </Grid>
            <Grid size={{xs: 6}}>
                <Typography sx={{fontSize: '16px', textAlign: 'right'}}>
                    $ {(+carRate?.finalTotal || +carRateFromAI?.total)?.toFixed(2)}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography sx={{fontSize: '16px', textAlign: 'left'}}>
                    {lng === 'cn' ? '预计运输时间:' : "Estimated shipping time:"} {carRate?.shippingDaysRange || carRateFromAI?.days ? `${carRate?.shippingDaysRange || carRateFromAI?.days} ${lng === 'cn' ? '天' : "days"}` : 'N/A'}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Typography>
                    {lng === 'cn' ? '预估费用仅供参考。' : "The estimated cost is for reference only."}
                </Typography>
            </Grid>
            <Grid size={{xs: 12}}>
                <Feedback/>
            </Grid>
            <Grid size={{xs: 12}}>
                <RegisterLink/>
            </Grid>
            <Grid size={{xs: 12}}>
                <Coupon/>
            </Grid>
            {
                redirectToApp()
            }
        </Fragment>
    )
}